
    import Component from "vue-class-component";
    import {ApprovalStatus, factory, SeafarerModel, SeafarerProfileLightViewModel, SeafarersClient} from "@/api-client";
    import QualificationResultModalBase
        from "@/features/documents/qualifications/records/components/QualificationResultModalBase";
    import {debounceFn} from "debounce-decorator-ts";
    import {ls} from "@/CultureService";
    import {formatDate} from "@/formatting/dateFormatter";
    import {Prop} from "vue-property-decorator";
    import Loader from "@/features/shared/components/Loader";

    @Component
    export default class QualificationResultAddModal extends QualificationResultModalBase {       
    
        @Prop({default: false})
        onlyActive!:boolean;
        
        seafarers: SeafarerProfileLightViewModel[] = [];
        
        searching = new Loader();
        typing = false;
    
        @Prop({default: false})
        isRecordSubmitted!:boolean;
        
        getDescription(seafarer: SeafarerProfileLightViewModel){
            return `${seafarer.firstName} ${seafarer.lastName} ${this.getIdentifier(seafarer)} ${
                seafarer.approval == ApprovalStatus.Approved
                ? ``
                : `<span class="badge badge-danger float-right">${ls.Global_Badge_PersonalInfoNotApproved_Short}</span>`
            }`;
        }
        
        getIdentifier(seafarer: SeafarerProfileLightViewModel) {
            if (seafarer.personalCode == null) {
                return `(${formatDate(seafarer.birthDate)}, ${
                    seafarer.nationality ?? this.$ls.Documents_Qualifications_Modal_AddQualificationResult_Nationality_Undefined
                })`;
            }
            else {
                return `(${seafarer.personalCode})`;
            }          
        }

        selectSeafarer(seafarer: SeafarerProfileLightViewModel){
            this.selectedSeafarer = seafarer;
            if (!this.result.seafarer) {
                this.result.seafarer = {} as SeafarerModel;
            }

            this.result.seafarer.id = seafarer?.id;
            this.result.seafarer.firstName = seafarer?.firstName;
            this.result.seafarer.lastName = seafarer?.lastName;
            this.result.seafarer.personalCode = seafarer?.personalCode;
        }
        
        get noResultText(){
            return this.searching.loading
                ? this.$ls.Global_Placeholder_Searching
                : this.typing
                    ? this.$ls.Documents_Qualifications_Modal_AddQualificationResult_Placeholder_SearchSeafarerName 
                    : this.$ls.Documents_Qualifications_Modal_AddQualificationResult_Placeholder_NoSeafarersFound;
        }

        async searchSeafarers(searchTerm: string){
            this.typing = true;
            await this.searchSeafarersDebounced(searchTerm);
            this.typing = false;
        }
        
        @debounceFn(500, "searchSeafarersFn")
        async searchSeafarersDebounced(searchTerm: string){
            if(searchTerm.trim() !== ''){
                const seafarers = (await new SeafarersClient()
                    .setLoader(this.searching)
                    .search(
                        this.onlyActive,
                        null,
                        1,
                        200,
                        searchTerm)
                        ).pageResult;
                const approved = seafarers.filter(s => s.approval === ApprovalStatus.Approved);
                const notApproved = seafarers.filter(s => s.approval !== ApprovalStatus.Approved);
                this.seafarers = approved.concat(notApproved); // Not approved seafarers to the end of the selection.
            }
            else{
                this.seafarers = [];
            }
        }
    }
